import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary
      context={{ screen: 'app' }}
      fallback={({ eventId }) => (
        <div className="screen">
          <h1>Something went wrong</h1>
          <p>Please reopen your session link. Reference: {eventId}</p>
        </div>
      )}
    >
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
